import { FormControl } from "@angular/forms";



export function AREA_COORDS_VALIDATOR(control: FormControl) {
    
    const isValid = control.value ? (control.value.length >= 2) : true;
    return isValid ? null : { 'invalid_area_coords': true };
}